import { v4 as uuidv4 } from "uuid";
import { defaultUnitsV2 } from "../../../../sustell_15/utils/unit-utils";
import { UserProfilePrefs } from "../../../Helpers/UserProfilePrefs";

import {
    createCoreForm,
    mapResourceUse,
    isValidValue
} from "./inCommonMapperSustellV2";
import {
    getDefaultTransportUnit,
    getUserTransportUnit,
    setInterventionFloatValue
} from "../../Baseline/mapper/inCommonMapperSustellV2";

import { floatValueInDefaultUnit } from "../../Baseline/mapper/floatHelperFunctions";
import { StageType } from "../../../../../graphql/types";
import { InputAnimalOrigin } from "../../../../../graphql/generated/blonk/cattle";

import {
    InterventionFeed,
    InterventionPropertyValue
} from "../../../../sustell_15/models/Intervention/Intervention";
import {
    DairyV2ContinuousGrowingStageData,
    DairyV2DairyCowStageData,
    DairyV2Input,
    DairyV2InputContinuousGrowing,
    DairyV2MilkProduction,
    DairyV2OutputContinuousGrowing,
    DairyV2OutputDairyCow,
} from "../../../../sustell_15/models/Intervention/DairyV2Intervention";
import {
    CommonStageInputDBModel,
    ContinousGrowingStageInputDBModel,
    ContinuousGrowingOutputDBModel,
    DairyCowOutputDBModel,
    DairyV2CommonStageDataDBModel,
    DairyV2ContinuousGrowingStageDataDBModel,
    DairyV2DairyCowStageDataDBModel,
    DairyV2InterventionDBModel,
    DairyV2StageDBModel,
    EmissionsDBModel
} from "../../../../sustell_15/models/TempBackendModels/TempInterventionModels/TempDairyV2InterventionDB";
import {
    CattleHousingAndManure as InterventionCattleHousingAndManure,
    CattleBeddingSystem as InterventionCattleBeddingSystem,
    CattleManureManagementSystem as InterventionCattleManureManagementSystem,
    CattleEmission,
    CattleFeed,
    InternalSource as InterventionInternalSource,
    ExternalSource as InterventionExternalSource,
    FreshGrass as InterventionFreshGrass
} from "../../../../sustell_15/models/Intervention/CattleIntervention";
import {
    CattleAnimalInputDBModel,
    CattleMilkProductionDBModel,
    FeedingProgramCalfDBModel,
    SingleIngredientUseDBModel as TempInterventionSingleIngredientUseDBModel,
    CattleBeddingDBModel as TempInterventionCattleBeddingDBModel,
    CattleManureManagementSystemDBModel as TempInterventionCattleManureManagementSystemDBModel,
    CompoundFeedInfoDBModel as TempInterventionCompoundFeedInfoDBModel,
    FreshGrassDBModel as TempInterventionFreshGrassDBModel,
} from "../../../../sustell_15/models/TempBackendModels/TempInterventionModels/TempCattleInterventionDB";
import {
    BaselineFeed,
    BaselineFeedWithOrigin
} from "../../../../sustell_15/models/Baseline/Baseline";
import {
    CattleBeddingSystem,
    CattleManureManagementSystem,
} from "../../../../sustell_15/models/Baseline/CattleBaseline";
import {
    CompoundFeedInfoDBModel as BaselineCompoundFeedInfoDBModel,
    CattleBeddingDBModel,
    CattleManureManagementSystemDBModel,
    SingleIngredientUseDBModel as BaselineSingleIngredientUseDBModel,
    FreshGrassDBModel as BaselineFreshGrassDBModel
} from "../../../../sustell_15/models/TempBackendModels/TempCattleDB";

const initStageData = (stageType: string) => {
    if (stageType === StageType.DairyCow) {
        return {
            input: {
                animalProductivity: '',
                startDate: '',

                animalsPresentAtStart: '',
                animalsPresentAtStart_newValue: '',
                animalsPresentAtStart_changeMetric: '',

                animalsPresentAtEnd: '',
                animalsPresentAtEnd_newValue: '',
                animalsPresentAtEnd_changeMetric: '',

                averageWeightAtStart: '',
                averageWeightAtStart_newValue: '',
                averageWeightAtStart_changeMetric: '',

                averageWeightNewAnimals: '',
                averageWeightNewAnimals_newValue: '',
                averageWeightNewAnimals_changeMetric: '',

                internalSources: [],
                externalSources: [],
                internalSourcesAdditions: [],
                externalSourcesAdditions: [],
            },
            feed: {
                databaseFoundation: '',

                compoundFeeds: [],
                singleIngredients: [],
                freshGrass: [],

                compoundFeedsAdditions: [],
                singleIngredientsAdditions: [],
                freshGrassAdditions: [],
            },
            housing: {
                timeInFeedlot: '',
                timeInFeedlot_newValue: '',
                timeInFeedlot_changeMetric: '',

                timeInHousing: '',
                timeInHousing_newValue: '',
                timeInHousing_changeMetric: '',

                timeGrazingLargeAreas: '',
                timeGrazingLargeAreas_newValue: '',
                timeGrazingLargeAreas_changeMetric: '',

                timeGrazingPastures: '',
                timeGrazingPastures_newValue: '',
                timeGrazingPastures_changeMetric: '',

                timeInHousingTied: '',
                timeInHousingTied_newValue: '',
                timeInHousingTied_changeMetric: '',

                manureSystems: [],
                beddingSystems: [],

                manureSystemsAdditions: [],
                beddingSystemsAdditions: [],
            },
            output: {
                cowsToAnotherStage: '',
                cowsToAnotherStage_newValue: '',
                cowsToAnotherStage_changeMetric: '',

                averageWeightOfCowsLeavingTheStage: '',
                averageWeightOfCowsLeavingTheStage_newValue: '',
                averageWeightOfCowsLeavingTheStage_changeMetric: '',

                cowsSold: '',
                cowsSold_newValue: '',
                cowsSold_changeMetric: '',

                pricePerCowSold: '',
                pricePerCowSold_newValue: '',
                pricePerCowSold_changeMetric: '',

                numberOfMortalitiesCows: '',
                numberOfMortalitiesCows_newValue: '',
                numberOfMortalitiesCows_changeMetric: '',

                averageWeightAtMortalityCows: '',
                averageWeightAtMortalityCows_newValue: '',
                averageWeightAtMortalityCows_changeMetric: '',

                weanedCalvesToAnotherStage: '',
                weanedCalvesToAnotherStage_newValue: '',
                weanedCalvesToAnotherStage_changeMetric: '',

                weanedCalvesSold: '',
                weanedCalvesSold_newValue: '',
                weanedCalvesSold_changeMetric: '',

                averageWeightAtBirth: '',
                averageWeightAtBirth_newValue: '',
                averageWeightAtBirth_changeMetric: '',

                averageMilkFat: '',
                averageMilkFat_newValue: '',
                averageMilkFat_changeMetric: '',

                averageMilkProtein: '',
                averageMilkProtein_newValue: '',
                averageMilkProtein_changeMetric: '',

                yearlyMilkProduction: '',
                yearlyMilkProduction_newValue: '',
                yearlyMilkProduction_changeMetric: '',
            },
            emissions: {
                emissionMitigations: {
                    methaneEntericFermentation: '',
                    methaneEntericFermentation_newValue: '',
                    methaneEntericFermentation_changeMetric: '',

                    nmvoc: '',
                    nmvoc_newValue: '',
                    nmvoc_changeMetric: '',

                    methaneMms: '',
                    methaneMms_newValue: '',
                    methaneMms_changeMetric: '',

                    nitrousOxideLeaching: '',
                    nitrousOxideLeaching_newValue: '',
                    nitrousOxideLeaching_changeMetric: '',

                    nitrousOxideDirect: '',
                    nitrousOxideDirect_newValue: '',
                    nitrousOxideDirect_changeMetric: '',

                    nitrousOxideVolatilization: '',
                    nitrousOxideVolatilization_newValue: '',
                    nitrousOxideVolatilization_changeMetric: '',

                    nitrogenOxidesStorage: '',
                    nitrogenOxidesStorage_newValue: '',
                    nitrogenOxidesStorage_changeMetric: '',

                    ammoniaStorage: '',
                    ammoniaStorage_newValue: '',
                    ammoniaStorage_changeMetric: '',

                    ammoniaHousing: '',
                    ammoniaHousing_newValue: '',
                    ammoniaHousing_changeMetric: '',

                    ammoniaYard: '',
                    ammoniaYard_newValue: '',
                    ammoniaYard_changeMetric: '',

                    pm2_5: '',
                    pm2_5_newValue: '',
                    pm2_5_changeMetric: '',

                    pm10: '',
                    pm10_newValue: '',
                    pm10_changeMetric: '',

                    tsp: '',
                    tsp_newValue: '',
                    tsp_changeMetric: '',
                },
            },
        };
    };

    if (stageType === StageType.ContinuousGrowing) {
        return {
            input: {
                averageWeightAtEnd: '',
                averageWeightAtEnd_newValue: '',
                averageWeightAtEnd_changeMetric: '',

                averageAge: '',
                averageAge_newValue: '',
                averageAge_changeMetric: '',

                animalProductivity: '',
                startDate: '',

                animalsPresentAtStart: '',
                animalsPresentAtStart_newValue: '',
                animalsPresentAtStart_changeMetric: '',

                animalsPresentAtEnd: '',
                animalsPresentAtEnd_newValue: '',
                animalsPresentAtEnd_changeMetric: '',

                averageWeightAtStart: '',
                averageWeightAtStart_newValue: '',
                averageWeightAtStart_changeMetric: '',

                averageWeightNewAnimals: '',
                averageWeightNewAnimals_newValue: '',
                averageWeightNewAnimals_changeMetric: '',

                internalSources: [],
                externalSources: [],
                internalSourcesAdditions: [],
                externalSourcesAdditions: [],
            },
            feed: {
                databaseFoundation: '',

                dietCharacterisation: '',
                dietCharacterisation_newValue: '',
                dietCharacterisation_changeMetric: '',

                mothersMilk: {
                    isMothersMilk: true,
                    isMothersMilk_newValue: '',
                    isMothersMilk_changeMetric: '',

                    amount: '',
                    amount_newValue: '',
                    amount_changeMetric: '',

                    crudeProteinContent: '',
                    crudeProteinContent_newValue: '',
                    crudeProteinContent_changeMetric: '',

                    digestibility: '',
                    digestibility_newValue: '',
                    digestibility_changeMetric: '',

                    dryMatterContent: '',
                    dryMatterContent_newValue: '',
                    dryMatterContent_changeMetric: '',
                },

                compoundFeeds: [],
                singleIngredients: [],
                freshGrass: [],

                compoundFeedsAdditions: [],
                singleIngredientsAdditions: [],
                freshGrassAdditions: [],
            },
            housing: {
                timeInFeedlot: '',
                timeInFeedlot_newValue: '',
                timeInFeedlot_changeMetric: '',

                timeInHousing: '',
                timeInHousing_newValue: '',
                timeInHousing_changeMetric: '',

                timeGrazingLargeAreas: '',
                timeGrazingLargeAreas_newValue: '',
                timeGrazingLargeAreas_changeMetric: '',

                timeGrazingPastures: '',
                timeGrazingPastures_newValue: '',
                timeGrazingPastures_changeMetric: '',

                manureSystems: [],
                beddingSystems: [],

                manureSystemsAdditions: [],
                beddingSystemsAdditions: [],
            },
            output: {
                averageAge: '',
                averageAge_newValue: '',
                averageAge_changeMetric: '',

                cowsToAnotherStage: '',
                cowsToAnotherStage_newValue: '',
                cowsToAnotherStage_changeMetric: '',

                averageWeightOfCowsLeavingTheStage: '',
                averageWeightOfCowsLeavingTheStage_newValue: '',
                averageWeightOfCowsLeavingTheStage_changeMetric: '',

                cowsSold: '',
                cowsSold_newValue: '',
                cowsSold_changeMetric: '',

                pricePerCowSold: '',
                pricePerCowSold_newValue: '',
                pricePerCowSold_changeMetric: '',

                numberOfMortalitiesCows: '',
                numberOfMortalitiesCows_newValue: '',
                numberOfMortalitiesCows_changeMetric: '',

                averageWeightAtMortalityCows: '',
                averageWeightAtMortalityCows_newValue: '',
                averageWeightAtMortalityCows_changeMetric: '',
            },
            emissions: {
                emissionMitigations: {
                    methaneEntericFermentation: '',
                    methaneEntericFermentation_newValue: '',
                    methaneEntericFermentation_changeMetric: '',

                    nmvoc: '',
                    nmvoc_newValue: '',
                    nmvoc_changeMetric: '',

                    methaneMms: '',
                    methaneMms_newValue: '',
                    methaneMms_changeMetric: '',

                    nitrousOxideLeaching: '',
                    nitrousOxideLeaching_newValue: '',
                    nitrousOxideLeaching_changeMetric: '',

                    nitrousOxideDirect: '',
                    nitrousOxideDirect_newValue: '',
                    nitrousOxideDirect_changeMetric: '',

                    nitrousOxideVolatilization: '',
                    nitrousOxideVolatilization_newValue: '',
                    nitrousOxideVolatilization_changeMetric: '',

                    ammoniaStorage: '',
                    ammoniaStorage_newValue: '',
                    ammoniaStorage_changeMetric: '',

                    ammoniaHousing: '',
                    ammoniaHousing_newValue: '',
                    ammoniaHousing_changeMetric: '',

                    ammoniaYard: '',
                    ammoniaYard_newValue: '',
                    ammoniaYard_changeMetric: '',

                    pm2_5: '',
                    pm2_5_newValue: '',
                    pm2_5_changeMetric: '',

                    pm10: '',
                    pm10_newValue: '',
                    pm10_changeMetric: '',

                    tsp: '',
                    tsp_newValue: '',
                    tsp_changeMetric: '',
                },
            },
        };
    };
};

const mapInputInternalSources = (
    internalSourcesBlockData: DairyV2Input,
    stageGeneralData: CommonStageInputDBModel | ContinousGrowingStageInputDBModel
) => {
    if (
        stageGeneralData.animals &&
        Array.isArray(stageGeneralData.animals)
    ) {
        stageGeneralData.animals?.forEach(
            (item: CattleAnimalInputDBModel) => {
                if (item.origin === InputAnimalOrigin.ProductionSystem) {
                    const inputData = {
                        id: item.id || uuidv4(),
                        farmId: item.originFarmId,
                        farmName: item.originFarmName,
                        originStageId: item.originStageId,
                        stageName: item.originStageName,
                        baselineRef: item.baselineRef,
                        animalType: item.animalType === "CALF" ? "CALF" : "COW",
                        stageType: item.stageType,
                        animalSystemType: item.animalSystemType,
                        distanceTruck: '',
                        numberAnimals: '',
                        origin: item.origin,
                        shrinkingRate: '',
                    };

                    if (isValidValue(item.transportDistance))
                        setInterventionFloatValue(
                            item,
                            "transportDistance",
                            inputData,
                            "distanceTruck",
                            getUserTransportUnit(item.transportDistance),
                            getDefaultTransportUnit(item.transportDistance)
                        );

                    if (isValidValue(item.numberOfAnimals))
                        setInterventionFloatValue(
                            item,
                            "numberOfAnimals",
                            inputData,
                            "numberAnimals"
                        );

                    if (isValidValue(item.shrinkingRate))
                        setInterventionFloatValue(
                            item,
                            "shrinkingRate",
                            inputData,
                            "shrinkingRate"
                        );

                    internalSourcesBlockData.internalSources?.push(
                        inputData as InterventionInternalSource
                    );
                }
            }
        );
    }
}

const mapInputExternalSources = (
    externalSourcesBlockData: DairyV2Input,
    stageGeneralData: CommonStageInputDBModel | ContinousGrowingStageInputDBModel
) => {
    if (
        stageGeneralData.animals &&
        Array.isArray(stageGeneralData.animals)
    ) {
        stageGeneralData.animals?.forEach(
            (item: CattleAnimalInputDBModel) => {
                if (item.origin === InputAnimalOrigin.BackgroundData) {
                    const externalSource = {
                        id: item.id || uuidv4(),
                        distanceTruck: '',
                        numberAnimals: '',
                        origin: item.origin,
                        shrinkingRate: '',
                    };

                    if (isValidValue(item.transportDistance))
                        setInterventionFloatValue(
                            item,
                            "transportDistance",
                            externalSource,
                            "distanceTruck"
                        );

                    if (isValidValue(item.numberOfAnimals))
                        setInterventionFloatValue(
                            item,
                            "numberOfAnimals",
                            externalSource,
                            "numberAnimals"
                        );

                    if (isValidValue(item.shrinkingRate))
                        setInterventionFloatValue(
                            item,
                            "shrinkingRate",
                            externalSource,
                            "shrinkingRate"
                        );

                    externalSourcesBlockData?.externalSources?.push(
                        externalSource as InterventionExternalSource
                    );
                }
            }
        );
    }
}

const mapInput = (
    inputBlockData: DairyV2Input | DairyV2InputContinuousGrowing,
    stageGeneralData: DairyV2DairyCowStageDataDBModel | DairyV2ContinuousGrowingStageDataDBModel
) => {
    if (isValidValue(stageGeneralData.stockChange.cowsPresentAtStart))
        setInterventionFloatValue(
            stageGeneralData.stockChange,
            "cowsPresentAtStart",
            inputBlockData,
            "animalsPresentAtStart"
        );

    if (isValidValue(stageGeneralData.stockChange.cowsPresentAtEnd))
        setInterventionFloatValue(
            stageGeneralData.stockChange,
            "cowsPresentAtEnd",
            inputBlockData,
            "animalsPresentAtEnd"
        );

    if (isValidValue(stageGeneralData.stockChange.averageWeightCowsStart))
        setInterventionFloatValue(
            stageGeneralData.stockChange,
            "averageWeightCowsStart",
            inputBlockData,
            "averageWeightAtStart"
        );

    if (isValidValue(stageGeneralData.input.averageWeight))
        setInterventionFloatValue(
            stageGeneralData.input,
            "averageWeight",
            inputBlockData,
            "averageWeightNewAnimals"
        );

    inputBlockData["cattleProductivity"] = stageGeneralData["animalProductivity"] as "HIGH" | "LOW";

    mapInputInternalSources(inputBlockData, stageGeneralData.input);
    mapInputExternalSources(inputBlockData, stageGeneralData.input);
}

const mapContinuousGrowingInput = (
    inputBlockData: DairyV2InputContinuousGrowing,
    stageGeneralData: DairyV2ContinuousGrowingStageDataDBModel
) => {
    if (isValidValue(stageGeneralData.stockChange.averageWeightCowsEnd))
        setInterventionFloatValue(
            stageGeneralData.stockChange,
            "averageWeightCowsEnd",
            inputBlockData,
            "averageWeightAtEnd"
        );

    if (isValidValue(stageGeneralData.input.averageAge))
        setInterventionFloatValue(
            stageGeneralData.input,
            "averageAge",
            inputBlockData,
            "averageAge"
        );

    mapInput(inputBlockData, stageGeneralData);
}

const mapCompoundFeeds = (
    feedBlockData: CattleFeed,
    stageGeneralData: FeedingProgramCalfDBModel
) => {
    const userPrefs = UserProfilePrefs.getInstance();
    const userUOM = userPrefs.getUserUnitPrefs();

    if (
        stageGeneralData.compoundFeeds &&
        Array.isArray(stageGeneralData.compoundFeeds)
    ) {
        stageGeneralData.compoundFeeds?.forEach(
            (item: TempInterventionCompoundFeedInfoDBModel) => {
                const compoundFeed = {
                    id: item.compoundFeedId || uuidv4(),
                    feedType: item.name,
                    kgPerAnimal: '',
                    origin: item.feedmillLocation
                };

                if (isValidValue(item.quantity))
                    setInterventionFloatValue(
                        item,
                        'quantity',
                        compoundFeed,
                        'kgPerAnimal',
                        userUOM.unitBarnOutputMass,
                        defaultUnitsV2.unitBarnOutputMass
                    );

                feedBlockData.compoundFeeds?.push(
                    compoundFeed as InterventionFeed
                );
            });
    }

    if (
        stageGeneralData.compoundFeedsAdditions &&
        Array.isArray(stageGeneralData.compoundFeedsAdditions)
    ) {
        stageGeneralData.compoundFeedsAdditions?.forEach(
            (item: BaselineCompoundFeedInfoDBModel) => {
                if (item.quantity) {
                    const value = floatValueInDefaultUnit(
                        item.quantity,
                        userUOM.unitBarnOutputMass,
                        defaultUnitsV2.unitBarnOutputMass
                    );

                    const compoundFeedAddition = {
                        id: item.compoundFeedId || uuidv4(),
                        feedType: item.name,
                        kgPerAnimal: value,
                    };

                    feedBlockData.compoundFeedsAdditions?.push(
                        compoundFeedAddition as BaselineFeed
                    );
                }
            });
    }
};

const mapSingleIngredients = (
    feedBlockData: CattleFeed,
    stageGeneralData: FeedingProgramCalfDBModel
) => {
    const userPrefs = UserProfilePrefs.getInstance();
    const userUOM = userPrefs.getUserUnitPrefs();

    if (
        stageGeneralData.singleIngredients &&
        Array.isArray(stageGeneralData.singleIngredients)
    ) {
        stageGeneralData.singleIngredients?.forEach(
            (item: TempInterventionSingleIngredientUseDBModel) => {
                if (item.quantity) {
                    const singleIngredient = {
                        id: item.ingredient.id || uuidv4(),
                        feedType: item.ingredient.name,
                        kgPerAnimal: '',
                        origin: item.ingredient.origin,
                    };

                    if (isValidValue(item.quantity))
                        setInterventionFloatValue(
                            item,
                            'quantity',
                            singleIngredient,
                            'kgPerAnimal',
                            userUOM.unitBarnOutputMass,
                            defaultUnitsV2.unitBarnOutputMass
                        );

                    feedBlockData.singleIngredients?.push(
                        singleIngredient as InterventionFeed
                    );
                }
            });
    }

    if (
        stageGeneralData.singleIngredientsAdditions &&
        Array.isArray(stageGeneralData.singleIngredientsAdditions)
    ) {
        stageGeneralData.singleIngredientsAdditions?.forEach(
            (item: BaselineSingleIngredientUseDBModel) => {
                if (item.quantity) {
                    const value = floatValueInDefaultUnit(
                        item.quantity,
                        userUOM.unitBarnOutputMass,
                        defaultUnitsV2.unitBarnOutputMass
                    );

                    const singleIngredientAddition = {
                        id: item.ingredient.id || uuidv4(),
                        feedType: item.ingredient.name,
                        origin: item.ingredient.origin,
                        kgPerAnimal: value,
                    };

                    feedBlockData.singleIngredientsAdditions?.push(
                        singleIngredientAddition as BaselineFeedWithOrigin
                    );
                }
            });
    }
};

const mapFreshGrass = (
    feedBlockData: CattleFeed,
    stageGeneralData: FeedingProgramCalfDBModel
) => {
    if (
        stageGeneralData.freshGrass &&
        Array.isArray(stageGeneralData.freshGrass)
    ) {
        stageGeneralData.freshGrass?.forEach(
            (item: TempInterventionFreshGrassDBModel) => {
                const freshGrass = {
                    id: item.id || uuidv4(),
                    type: item.type as string,
                    amount: {},
                    crudeProteinContent: {},
                    dryMatterContent: {},
                    digestibility: {},
                    neutralDetergentFiber: {},
                    grossEnergyContent: {},
                    ashContent: {}
                };

                if (isValidValue(item.amount))
                    setInterventionFloatValue(
                        item,
                        'amount',
                        freshGrass,
                        'amount',
                    );

                if (isValidValue(item.crudeProteinContent))
                    setInterventionFloatValue(
                        item,
                        'crudeProteinContent',
                        freshGrass,
                        'crudeProteinContent',
                    );

                if (isValidValue(item.dryMatterContent))
                    setInterventionFloatValue(
                        item,
                        'dryMatterContent',
                        freshGrass,
                        'dryMatterContent',
                    );

                if (isValidValue(item.digestibility))
                    setInterventionFloatValue(
                        item,
                        'digestibility',
                        freshGrass,
                        'digestibility',
                    );

                if (isValidValue(item.neutralDetergentFiber))
                    setInterventionFloatValue(
                        item,
                        'neutralDetergentFiber',
                        freshGrass,
                        'neutralDetergentFiber',
                    );

                if (isValidValue(item.grossEnergyContent))
                    setInterventionFloatValue(
                        item,
                        'grossEnergyContent',
                        freshGrass,
                        'grossEnergyContent',
                    );

                if (isValidValue(item.ashContent))
                    setInterventionFloatValue(
                        item,
                        'ashContent',
                        freshGrass,
                        'ashContent',
                    );

                feedBlockData.freshGrass?.push(
                    freshGrass as InterventionFreshGrass
                );
            });
    }

    if (
        stageGeneralData.freshGrassAdditions &&
        Array.isArray(stageGeneralData.freshGrassAdditions)
    ) {
        stageGeneralData.freshGrassAdditions?.forEach(
            (item: BaselineFreshGrassDBModel) => {
                const grassAddition = {
                    id: item.id || uuidv4(),
                    type: item.type,
                    amount: floatValueInDefaultUnit(
                        item.amount,
                    ),
                    crudeProteinContent: floatValueInDefaultUnit(
                        item.crudeProteinContent,
                    ),
                    dryMatterContent: floatValueInDefaultUnit(
                        item.dryMatterContent,
                    ),
                    digestibility: floatValueInDefaultUnit(
                        item.digestibility,
                    ),
                    neutralDetergentFiber: floatValueInDefaultUnit(
                        item.neutralDetergentFiber,
                    ),
                    grossEnergyContent: floatValueInDefaultUnit(
                        item.grossEnergyContent,
                    ),
                    ashContent: floatValueInDefaultUnit(
                        item.ashContent,
                    ),
                };

                feedBlockData.freshGrassAdditions?.push(
                    grassAddition
                );
            });
    }
};

const mapFeed = (
    feedBlockData: CattleFeed,
    stageGeneralData: FeedingProgramCalfDBModel
) => {
    mapCompoundFeeds(feedBlockData, stageGeneralData);
    mapSingleIngredients(feedBlockData, stageGeneralData);
    mapFreshGrass(feedBlockData, stageGeneralData);
}

const mapContinuousGrowingFeed = (
    feedBlockData: CattleFeed,
    stageGeneralData: FeedingProgramCalfDBModel
) => {
    if (stageGeneralData.mothersMilk) {
        const { mothersMilk } = stageGeneralData;

        if (isValidValue(mothersMilk.amount))
            setInterventionFloatValue(
                mothersMilk,
                "amount",
                feedBlockData.mothersMilk,
                "amount"
            );

        if (isValidValue(mothersMilk.crudeProteinContent))
            setInterventionFloatValue(
                mothersMilk,
                "crudeProteinContent",
                feedBlockData.mothersMilk,
                "crudeProteinContent"
            );

        if (isValidValue(mothersMilk.digestibility))
            setInterventionFloatValue(
                mothersMilk,
                "digestibility",
                feedBlockData.mothersMilk,
                "digestibility"
            );

        if (isValidValue(mothersMilk.dryMatterContent))
            setInterventionFloatValue(
                mothersMilk,
                "dryMatterContent",
                feedBlockData.mothersMilk,
                "dryMatterContent"
            );
    }

    mapFeed(feedBlockData, stageGeneralData);
}

const mapBeddingType = (
    beddingBlockData: InterventionCattleHousingAndManure,
    stageGeneralData: DairyV2CommonStageDataDBModel
) => {
    const userPrefs = UserProfilePrefs.getInstance();
    const userUOM = userPrefs.getUserUnitPrefs();
    const outputMassPrecision = userPrefs.getUnitOutputMassPrecision();
    const { bedding, beddingAdditions } = stageGeneralData;

    if (
        bedding &&
        Array.isArray(bedding)
    ) {
        bedding.forEach(
            (item: TempInterventionCattleBeddingDBModel) => {
                if (item) {
                    const beddingType = {
                        id: item.id || uuidv4(),
                        beddingType: item.type,
                        beddingAmount: ''
                    }

                    if (isValidValue(item.amount))
                        setInterventionFloatValue(
                            item,
                            "amount",
                            beddingType,
                            "beddingAmount",
                            userUOM.unitOutputMass,
                            defaultUnitsV2.unitOutputMass,
                            outputMassPrecision
                        );

                    beddingBlockData?.beddingSystems?.push(
                        beddingType as InterventionCattleBeddingSystem
                    );
                }
            }
        )
    }

    if (
        beddingAdditions &&
        Array.isArray(beddingAdditions)
    ) {
        beddingAdditions.forEach(
            (item: CattleBeddingDBModel) => {
                if (item) {
                    const beddingAddition = {
                        id: item.id || uuidv4(),
                        beddingType: item.type,
                        beddingAmount: floatValueInDefaultUnit(
                            item.amount,
                            userUOM.unitBarnOutputMass,
                            defaultUnitsV2.unitBarnOutputMass
                        ),
                    }

                    beddingBlockData?.beddingSystemsAdditions?.push(
                        beddingAddition as CattleBeddingSystem
                    );
                }
            }
        )
    }
}

const mapMMSType = (
    mmsBlockData: InterventionCattleHousingAndManure,
    stageGeneralData: DairyV2CommonStageDataDBModel
) => {
    const { manureSystems } = mmsBlockData;
    const { mms } = stageGeneralData;

    if (
        mms &&
        Array.isArray(mms)
    ) {
        mms.forEach(
            (item: TempInterventionCattleManureManagementSystemDBModel) => {
                if (item) {
                    const mmsType = {
                        id: item.id || uuidv4(),
                        share: '',
                        mmsType: item.mmsType,
                        storagePeriod: '',
                        manurePhase: '',
                    }

                    setInterventionFloatValue(
                        item,
                        "storagePeriod",
                        mmsType,
                        "storagePeriod",
                    );

                    if (isValidValue(item.share))
                        setInterventionFloatValue(
                            item,
                            "share",
                            mmsType,
                            "share",
                        );

                    setInterventionFloatValue(
                        item,
                        "manurePhase",
                        mmsType,
                        "manurePhase",
                    );

                    manureSystems?.push(
                        mmsType as InterventionCattleManureManagementSystem
                    );
                }
            }
        )
    }

    if (
        mmsBlockData.manureSystemsAdditions &&
        Array.isArray(mmsBlockData.manureSystemsAdditions)
    ) {
        mmsBlockData.manureSystemsAdditions.forEach(
            (item: CattleManureManagementSystem) => {
                if (item) {
                    const mmsAddition = {
                        id: item.id || uuidv4(),
                        mmsType: item.mmsType,
                        storagePeriod: floatValueInDefaultUnit(
                            item.storagePeriod,
                        ),
                        share: floatValueInDefaultUnit(
                            item.share,
                        ),
                        manurePhase: floatValueInDefaultUnit(
                            item.manurePhase,
                        ),
                    }

                    stageGeneralData.mmsAdditions?.push(
                        mmsAddition as CattleManureManagementSystemDBModel
                    );
                }
            }
        )
    }
}

const mapHousingAndManureDairyCow = (
    housingBlockData: InterventionCattleHousingAndManure,
    stageGeneralData: DairyV2CommonStageDataDBModel
) => {
    if (isValidValue(stageGeneralData.timeSpent.timeInHousingTied))
        setInterventionFloatValue(
            stageGeneralData.timeSpent,
            "timeInHousingTied",
            housingBlockData,
            "timeInHousingTied"
        );

    mapHousingAndManure(housingBlockData, stageGeneralData);
}

const mapHousingAndManure = (
    housingBlockData: InterventionCattleHousingAndManure,
    stageGeneralData: DairyV2CommonStageDataDBModel
) => {
    setInterventionFloatValue(
        stageGeneralData.timeSpent,
        "timeInHousing",
        housingBlockData,
        "timeInHousing"
    );

    if (isValidValue(stageGeneralData.timeSpent.timeInFeedlot))
        setInterventionFloatValue(
            stageGeneralData.timeSpent,
            "timeInFeedlot",
            housingBlockData,
            "timeInFeedlot"
        );

    if (isValidValue(stageGeneralData.timeSpent.timeOnLargeGrazingAreas))
        setInterventionFloatValue(
            stageGeneralData.timeSpent,
            "timeOnLargeGrazingAreas",
            housingBlockData,
            "timeGrazingLargeAreas"
        );

    if (isValidValue(stageGeneralData.timeSpent.timeOnSmallGrazingAreas))
        setInterventionFloatValue(
            stageGeneralData.timeSpent,
            "timeOnSmallGrazingAreas",
            housingBlockData,
            "timeGrazingPastures"
        );

    mapBeddingType(housingBlockData, stageGeneralData);
    mapMMSType(housingBlockData, stageGeneralData);
}

const mapDairyCowOutputMilk = (
    milkBlockData: DairyV2MilkProduction,
    stageGeneralData: CattleMilkProductionDBModel
) => {
    const userPrefs = UserProfilePrefs.getInstance();
    const userUOM = userPrefs.getUserUnitPrefs();

    if (isValidValue(stageGeneralData.amount))
      setInterventionFloatValue(
        stageGeneralData,
        "amount",
        milkBlockData,
        "yearlyMilkProduction",
        userUOM.unitBarnOutputMass,
        defaultUnitsV2.unitBarnOutputMass,
      );

    if (isValidValue(stageGeneralData.fatContent))
        setInterventionFloatValue(
            stageGeneralData,
            "fatContent",
            milkBlockData,
            "averageMilkFat",
        );

    if (isValidValue(stageGeneralData.proteinContent))
        setInterventionFloatValue(
            stageGeneralData,
            "proteinContent",
            milkBlockData,
            "averageMilkProtein",
        );
}

const mapOutputCows = (
    outputBlockData: DairyV2OutputDairyCow | DairyV2OutputContinuousGrowing,
    stageGeneralData: DairyCowOutputDBModel | ContinuousGrowingOutputDBModel
) => {
    const userPrefs = UserProfilePrefs.getInstance();
    const userUOM = userPrefs.getUserUnitPrefs();
    const outputMassPrecision = userPrefs.getUnitOutputMassPrecision();

    if (isValidValue(stageGeneralData.animalsOutgoing))
        setInterventionFloatValue(
            stageGeneralData,
            "animalsOutgoing",
            outputBlockData,
            "cowsToAnotherStage",
        );

    if (isValidValue(stageGeneralData.averageWeight))
        setInterventionFloatValue(
            stageGeneralData,
            "averageWeight",
            outputBlockData,
            "averageWeightOfCowsLeavingTheStage",
            userUOM.unitOutputMass,
            defaultUnitsV2.unitOutputMass,
            outputMassPrecision
        );

    if (isValidValue(stageGeneralData.soldExternally))
        setInterventionFloatValue(
            stageGeneralData,
            "soldExternally",
            outputBlockData,
            "cowsSold",
        );

    if (isValidValue(stageGeneralData.mortalities))
        setInterventionFloatValue(
            stageGeneralData,
            "mortalities",
            outputBlockData,
            "numberOfMortalitiesCows",
        );

    if (isValidValue(stageGeneralData.weightAtMortality))
        setInterventionFloatValue(
            stageGeneralData,
            "weightAtMortality",
            outputBlockData,
            "averageWeightAtMortalityCows",
            userUOM.unitOutputMass,
            defaultUnitsV2.unitOutputMass,
            outputMassPrecision
        );
}

const mapDairyCowOutputCalves = (
    calvesBlockData: DairyV2OutputDairyCow,
    stageGeneralData: DairyV2DairyCowStageDataDBModel
) => {
    const userPrefs = UserProfilePrefs.getInstance();
    const userUOM = userPrefs.getUserUnitPrefs();
    
    if (isValidValue(stageGeneralData.outputCalves.animalsOutgoing))
        setInterventionFloatValue(
            stageGeneralData.outputCalves,
            "animalsOutgoing",
            calvesBlockData,
            "weanedCalvesToAnotherStage",
        );

    if (isValidValue(stageGeneralData.outputCalves.soldExternally))
        setInterventionFloatValue(
            stageGeneralData.outputCalves,
            "soldExternally",
            calvesBlockData,
            "weanedCalvesSold",
        );

    if (isValidValue(stageGeneralData.calvesBirthWeight))
      setInterventionFloatValue(
        stageGeneralData,
        "calvesBirthWeight",
        calvesBlockData,
        "averageWeightAtBirth",
        userUOM.unitBarnOutputMass,
        defaultUnitsV2.unitBarnOutputMass,
      );
}

const mapContinuousGrowingOutput = (
    outputBlockData: DairyV2OutputContinuousGrowing,
    stageGeneralData: ContinuousGrowingOutputDBModel
) => {
    if (isValidValue(stageGeneralData.averageAge))
        setInterventionFloatValue(
            stageGeneralData,
            "averageAge",
            outputBlockData,
            "averageAge",
        );

    mapOutputCows(outputBlockData, stageGeneralData);
}

const mapEmissionMitigations = (
    emissionsBlockData: CattleEmission,
    stageGeneralData: EmissionsDBModel
) => {
    const { emissionMitigations } = stageGeneralData;

    if (emissionMitigations && emissionMitigations.length !== 0) {
        emissionMitigations.forEach((item) => {
            const { emissionType, change } = item;

            if (change && emissionType) {
                const baseKey = emissionType as keyof CattleEmission;

                if (change.value !== undefined && change.value !== null)
                    (emissionsBlockData[baseKey] as InterventionPropertyValue) = change.value;

                const changeTypeKey = emissionType.concat("_changeMetric") as keyof CattleEmission;
                emissionsBlockData[changeTypeKey] = change.change_type;
            }
            else
                return;
        });
    }
    else
        return;
};

const mapStageInterventionDataInSustell = (stageBlockData: DairyV2StageDBModel) => {
    const { stageData } = stageBlockData;

    const oneStageData = {
        id: stageBlockData?.id || uuidv4(),
        name: stageBlockData?.name,
        type: stageBlockData?.type,
        startDate: stageBlockData?.startDate,
        stageData: { ...initStageData(stageBlockData.type as string) },
    };

    if (stageData) {
        if (stageBlockData.type == StageType.DairyCow) {
            const dairyCowStageData = stageData as DairyV2DairyCowStageDataDBModel;
            const { input, feed, housing, output, emissions } = oneStageData.stageData as DairyV2DairyCowStageData;

            if (input && dairyCowStageData)
                mapInput(input, dairyCowStageData);

            if (feed && dairyCowStageData.feedingProgram)
                mapFeed(feed, dairyCowStageData.feedingProgram);

            if (housing && dairyCowStageData)
                mapHousingAndManureDairyCow(housing, dairyCowStageData);

            if (output && dairyCowStageData) {
                mapOutputCows(output, dairyCowStageData.outputCows);
                mapDairyCowOutputMilk(output, dairyCowStageData.milkProduction);
                mapDairyCowOutputCalves(output, dairyCowStageData);
            }

            if (emissions?.emissionMitigations && dairyCowStageData.emissions) {
                mapEmissionMitigations(emissions?.emissionMitigations, dairyCowStageData.emissions);
            }
        }

        if (stageBlockData.type == StageType.ContinuousGrowing) {
            const continuousGrowingStageData = stageData as DairyV2ContinuousGrowingStageDataDBModel;
            const { input, feed, housing, output, emissions } = oneStageData.stageData as DairyV2ContinuousGrowingStageData;

            if (input && continuousGrowingStageData)
                mapContinuousGrowingInput(input, continuousGrowingStageData);

            if (feed && continuousGrowingStageData.feedingProgram)
                mapContinuousGrowingFeed(feed, continuousGrowingStageData.feedingProgram);

            if (housing && continuousGrowingStageData)
                mapHousingAndManure(housing, continuousGrowingStageData);

            if (output && continuousGrowingStageData.outputCows)
                mapContinuousGrowingOutput(output, continuousGrowingStageData.outputCows);

            if (emissions?.emissionMitigations && continuousGrowingStageData.emissions) {
                mapEmissionMitigations(emissions?.emissionMitigations, continuousGrowingStageData.emissions);
            }
        }
    }

    return oneStageData;
};

const mapDairyV2InterventionDataInSustell = (
    inDataObj: DairyV2InterventionDBModel
) => {
    if (inDataObj) {
        inDataObj.stages?.forEach((stage: DairyV2StageDBModel) => {
            if (stage.stageData && typeof stage.stageData === "string") {
                stage.stageData = JSON.parse(stage.stageData) || {};
            }
        });

        const payloadObj = createCoreForm(inDataObj);

        if (inDataObj.resourceUse)
            mapResourceUse(inDataObj.resourceUse, payloadObj.resourceUse);


        if (inDataObj.stages && Array.isArray(inDataObj.stages)) {
            return inDataObj.stages.reduce(
                (payload, stage) => {
                    const mappedStage = mapStageInterventionDataInSustell(stage);
                    return {
                        ...payload,
                        stages: [...payload.stages, mappedStage],
                    };
                },
                { ...payloadObj }
            );
        }

        return payloadObj;
    }

    return {};
};

export default mapDairyV2InterventionDataInSustell;
